/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getWARCertificatedTransactionCycle = /* GraphQL */ `
  query GetWARCertificatedTransactionCycle($id: ID!) {
    getWARCertificatedTransactionCycle(id: $id) {
      id
      reportId
      fromEmployeeId
      toEmployeeId
      status
      remark
      customUpdatedAt
      isApproved
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listWARCertificatedTransactionCycles = /* GraphQL */ `
  query ListWARCertificatedTransactionCycles(
    $filter: ModelWARCertificatedTransactionCycleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWARCertificatedTransactionCycles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reportId
        fromEmployeeId
        toEmployeeId
        status
        remark
        customUpdatedAt
        isApproved
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncWARCertificatedTransactionCycles = /* GraphQL */ `
  query SyncWARCertificatedTransactionCycles(
    $filter: ModelWARCertificatedTransactionCycleFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncWARCertificatedTransactionCycles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        reportId
        fromEmployeeId
        toEmployeeId
        status
        remark
        customUpdatedAt
        isApproved
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getWARClassifiedTransactionCycle = /* GraphQL */ `
  query GetWARClassifiedTransactionCycle($id: ID!) {
    getWARClassifiedTransactionCycle(id: $id) {
      id
      reportId
      fromEmployeeId
      toEmployeeId
      status
      isApproved
      remark
      customUpdatedAt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listWARClassifiedTransactionCycles = /* GraphQL */ `
  query ListWARClassifiedTransactionCycles(
    $filter: ModelWARClassifiedTransactionCycleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWARClassifiedTransactionCycles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reportId
        fromEmployeeId
        toEmployeeId
        status
        isApproved
        remark
        customUpdatedAt
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncWARClassifiedTransactionCycles = /* GraphQL */ `
  query SyncWARClassifiedTransactionCycles(
    $filter: ModelWARClassifiedTransactionCycleFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncWARClassifiedTransactionCycles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        reportId
        fromEmployeeId
        toEmployeeId
        status
        isApproved
        remark
        customUpdatedAt
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getPSAPartyDocument = /* GraphQL */ `
  query GetPSAPartyDocument($id: ID!) {
    getPSAPartyDocument(id: $id) {
      id
      reportId
      filename
      filepath
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listPSAPartyDocuments = /* GraphQL */ `
  query ListPSAPartyDocuments(
    $filter: ModelPSAPartyDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPSAPartyDocuments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reportId
        filename
        filepath
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncPSAPartyDocuments = /* GraphQL */ `
  query SyncPSAPartyDocuments(
    $filter: ModelPSAPartyDocumentFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncPSAPartyDocuments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        reportId
        filename
        filepath
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getPSADocuments = /* GraphQL */ `
  query GetPSADocuments($id: ID!) {
    getPSADocuments(id: $id) {
      id
      reportId
      filename
      filepath
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listPSADocuments = /* GraphQL */ `
  query ListPSADocuments(
    $filter: ModelPSADocumentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPSADocuments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reportId
        filename
        filepath
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncPSADocuments = /* GraphQL */ `
  query SyncPSADocuments(
    $filter: ModelPSADocumentsFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncPSADocuments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        reportId
        filename
        filepath
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getPersonnelActionFormBudgetCode = /* GraphQL */ `
  query GetPersonnelActionFormBudgetCode($id: ID!) {
    getPersonnelActionFormBudgetCode(id: $id) {
      id
      employeesId
      budgetCodes
      budgetName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listPersonnelActionFormBudgetCodes = /* GraphQL */ `
  query ListPersonnelActionFormBudgetCodes(
    $filter: ModelPersonnelActionFormBudgetCodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPersonnelActionFormBudgetCodes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeesId
        budgetCodes
        budgetName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncPersonnelActionFormBudgetCodes = /* GraphQL */ `
  query SyncPersonnelActionFormBudgetCodes(
    $filter: ModelPersonnelActionFormBudgetCodeFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncPersonnelActionFormBudgetCodes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        employeesId
        budgetCodes
        budgetName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getUserAdditionalSettings = /* GraphQL */ `
  query GetUserAdditionalSettings($id: ID!) {
    getUserAdditionalSettings(id: $id) {
      id
      userId
      stipendApprover
      stipendInitiator
      stipendPayroll
      subReqClassifiedInitiator
      subReqClassifiedApprover
      subReqClassifiedPayroll
      personnelServiceAgreeInitiator
      personnelServiceAgreeApprover
      personnelServiceAgreePayroll
      subReqClassifiedSuperAdmin
      isWARClassifiedSuperAdmin
      isWARCertificatedSuperAdmin
      isStipendSuperAdmin
      isSixthPeriodSuperAdmin
      isPersonalServiceSuperAdmin
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listUserAdditionalSettings = /* GraphQL */ `
  query ListUserAdditionalSettings(
    $filter: ModelUserAdditionalSettingsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserAdditionalSettings(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        stipendApprover
        stipendInitiator
        stipendPayroll
        subReqClassifiedInitiator
        subReqClassifiedApprover
        subReqClassifiedPayroll
        personnelServiceAgreeInitiator
        personnelServiceAgreeApprover
        personnelServiceAgreePayroll
        subReqClassifiedSuperAdmin
        isWARClassifiedSuperAdmin
        isWARCertificatedSuperAdmin
        isStipendSuperAdmin
        isSixthPeriodSuperAdmin
        isPersonalServiceSuperAdmin
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncUserAdditionalSettings = /* GraphQL */ `
  query SyncUserAdditionalSettings(
    $filter: ModelUserAdditionalSettingsFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncUserAdditionalSettings(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        userId
        stipendApprover
        stipendInitiator
        stipendPayroll
        subReqClassifiedInitiator
        subReqClassifiedApprover
        subReqClassifiedPayroll
        personnelServiceAgreeInitiator
        personnelServiceAgreeApprover
        personnelServiceAgreePayroll
        subReqClassifiedSuperAdmin
        isWARClassifiedSuperAdmin
        isWARCertificatedSuperAdmin
        isStipendSuperAdmin
        isSixthPeriodSuperAdmin
        isPersonalServiceSuperAdmin
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getLoginEmail = /* GraphQL */ `
  query GetLoginEmail($id: ID!) {
    getLoginEmail(id: $id) {
      id
      firstName
      email
      password
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listLoginEmails = /* GraphQL */ `
  query ListLoginEmails(
    $filter: ModelLoginEmailFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLoginEmails(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstName
        email
        password
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncLoginEmails = /* GraphQL */ `
  query SyncLoginEmails(
    $filter: ModelLoginEmailFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncLoginEmails(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        firstName
        email
        password
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getPersonnelActionEmployee = /* GraphQL */ `
  query GetPersonnelActionEmployee($id: ID!) {
    getPersonnelActionEmployee(id: $id) {
      id
      employeeId
      employeeName
      salaryRate
      rateofPay
      reason
      fundingSource
      accountNo
      budgetCode
      effectiveDatesTo
      effectiveDatesFrom
      positionTitleTo
      positionTitleFrom
      created_by
      submited_by
      formId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listPersonnelActionEmployees = /* GraphQL */ `
  query ListPersonnelActionEmployees(
    $filter: ModelPersonnelActionEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPersonnelActionEmployees(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        employeeName
        salaryRate
        rateofPay
        reason
        fundingSource
        accountNo
        budgetCode
        effectiveDatesTo
        effectiveDatesFrom
        positionTitleTo
        positionTitleFrom
        created_by
        submited_by
        formId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncPersonnelActionEmployees = /* GraphQL */ `
  query SyncPersonnelActionEmployees(
    $filter: ModelPersonnelActionEmployeeFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncPersonnelActionEmployees(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        employeeId
        employeeName
        salaryRate
        rateofPay
        reason
        fundingSource
        accountNo
        budgetCode
        effectiveDatesTo
        effectiveDatesFrom
        positionTitleTo
        positionTitleFrom
        created_by
        submited_by
        formId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getTransactionCyclePersonnel = /* GraphQL */ `
  query GetTransactionCyclePersonnel($id: ID!) {
    getTransactionCyclePersonnel(id: $id) {
      id
      report_Id
      from_Employee_Id
      to_Employee_Id
      status
      isApproved
      remark
      date
      signature_File_Path
      approver_level
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listTransactionCyclePersonnels = /* GraphQL */ `
  query ListTransactionCyclePersonnels(
    $filter: ModelTransactionCyclePersonnelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTransactionCyclePersonnels(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        report_Id
        from_Employee_Id
        to_Employee_Id
        status
        isApproved
        remark
        date
        signature_File_Path
        approver_level
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncTransactionCyclePersonnels = /* GraphQL */ `
  query SyncTransactionCyclePersonnels(
    $filter: ModelTransactionCyclePersonnelFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncTransactionCyclePersonnels(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        report_Id
        from_Employee_Id
        to_Employee_Id
        status
        isApproved
        remark
        date
        signature_File_Path
        approver_level
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getPreSignupEmployeeApps = /* GraphQL */ `
  query GetPreSignupEmployeeApps($id: ID!) {
    getPreSignupEmployeeApps(id: $id) {
      id
      email
      appId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listPreSignupEmployeeApps = /* GraphQL */ `
  query ListPreSignupEmployeeApps(
    $filter: ModelPreSignupEmployeeAppsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPreSignupEmployeeApps(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        appId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncPreSignupEmployeeApps = /* GraphQL */ `
  query SyncPreSignupEmployeeApps(
    $filter: ModelPreSignupEmployeeAppsFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncPreSignupEmployeeApps(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        email
        appId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getPreSignupEmployee = /* GraphQL */ `
  query GetPreSignupEmployee($id: ID!) {
    getPreSignupEmployee(id: $id) {
      id
      email
      role
      reportingMangerEmail
      employeeCode
      employeeName
      schoolCode
      userType
      isSixPeriodSAdmin
      sixPeriodIsInitiator
      sixPeriodIsApprover
      sixPeriodIsPayroll
      certiSubRIsInitiator
      certiSubReIsApprover
      certiSubReqIsPayroll
      designation
      isUser
      timeRIsInitiator
      timeRIsApprover
      timeRIsPayroll
      timeRIsSAdmin
      stipendInitiator
      stipendApprover
      stipendPayroll
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listPreSignupEmployees = /* GraphQL */ `
  query ListPreSignupEmployees(
    $filter: ModelPreSignupEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPreSignupEmployees(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        role
        reportingMangerEmail
        employeeCode
        employeeName
        schoolCode
        userType
        isSixPeriodSAdmin
        sixPeriodIsInitiator
        sixPeriodIsApprover
        sixPeriodIsPayroll
        certiSubRIsInitiator
        certiSubReIsApprover
        certiSubReqIsPayroll
        designation
        isUser
        timeRIsInitiator
        timeRIsApprover
        timeRIsPayroll
        timeRIsSAdmin
        stipendInitiator
        stipendApprover
        stipendPayroll
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncPreSignupEmployees = /* GraphQL */ `
  query SyncPreSignupEmployees(
    $filter: ModelPreSignupEmployeeFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncPreSignupEmployees(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        email
        role
        reportingMangerEmail
        employeeCode
        employeeName
        schoolCode
        userType
        isSixPeriodSAdmin
        sixPeriodIsInitiator
        sixPeriodIsApprover
        sixPeriodIsPayroll
        certiSubRIsInitiator
        certiSubReIsApprover
        certiSubReqIsPayroll
        designation
        isUser
        timeRIsInitiator
        timeRIsApprover
        timeRIsPayroll
        timeRIsSAdmin
        stipendInitiator
        stipendApprover
        stipendPayroll
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getPersonnelActionTransactionCycle = /* GraphQL */ `
  query GetPersonnelActionTransactionCycle($id: ID!) {
    getPersonnelActionTransactionCycle(id: $id) {
      id
      report_Id
      from_Employee_Id
      to_Employee_Id
      isApproved
      remark
      date
      status
      signature_File_Path
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listPersonnelActionTransactionCycles = /* GraphQL */ `
  query ListPersonnelActionTransactionCycles(
    $filter: ModelPersonnelActionTransactionCycleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPersonnelActionTransactionCycles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        report_Id
        from_Employee_Id
        to_Employee_Id
        isApproved
        remark
        date
        status
        signature_File_Path
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncPersonnelActionTransactionCycles = /* GraphQL */ `
  query SyncPersonnelActionTransactionCycles(
    $filter: ModelPersonnelActionTransactionCycleFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncPersonnelActionTransactionCycles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        report_Id
        from_Employee_Id
        to_Employee_Id
        isApproved
        remark
        date
        status
        signature_File_Path
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getPersonnelActionFormTransactionCycle = /* GraphQL */ `
  query GetPersonnelActionFormTransactionCycle($id: ID!) {
    getPersonnelActionFormTransactionCycle(id: $id) {
      id
      report_Id
      from_Employee_Id
      to_Employee_Id
      isApproved
      remark
      date
      status
      signature_File_Path
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listPersonnelActionFormTransactionCycles = /* GraphQL */ `
  query ListPersonnelActionFormTransactionCycles(
    $filter: ModelPersonnelActionFormTransactionCycleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPersonnelActionFormTransactionCycles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        report_Id
        from_Employee_Id
        to_Employee_Id
        isApproved
        remark
        date
        status
        signature_File_Path
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncPersonnelActionFormTransactionCycles = /* GraphQL */ `
  query SyncPersonnelActionFormTransactionCycles(
    $filter: ModelPersonnelActionFormTransactionCycleFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncPersonnelActionFormTransactionCycles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        report_Id
        from_Employee_Id
        to_Employee_Id
        isApproved
        remark
        date
        status
        signature_File_Path
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getPersonnelActionInitiatorForm = /* GraphQL */ `
  query GetPersonnelActionInitiatorForm($id: ID!) {
    getPersonnelActionInitiatorForm(id: $id) {
      id
      formTitle
      boardMeetingDate
      location
      actionToBeTaken
      type
      personalReportNo
      deptHead
      budgetClerk
      budgetManager
      executiveSecretary
      executiveManagement
      submited_by
      created_by
      hrTechnician
      executivedirelemId
      assignelemorsec
      psayesorno
      actionDate
      actionItem
      actionPage
      referenceNo
      isDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listPersonnelActionInitiatorForms = /* GraphQL */ `
  query ListPersonnelActionInitiatorForms(
    $filter: ModelPersonnelActionInitiatorFormFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPersonnelActionInitiatorForms(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        formTitle
        boardMeetingDate
        location
        actionToBeTaken
        type
        personalReportNo
        deptHead
        budgetClerk
        budgetManager
        executiveSecretary
        executiveManagement
        submited_by
        created_by
        hrTechnician
        executivedirelemId
        assignelemorsec
        psayesorno
        actionDate
        actionItem
        actionPage
        referenceNo
        isDelete
        isArchived
        isArchivedUsers
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncPersonnelActionInitiatorForms = /* GraphQL */ `
  query SyncPersonnelActionInitiatorForms(
    $filter: ModelPersonnelActionInitiatorFormFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncPersonnelActionInitiatorForms(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        formTitle
        boardMeetingDate
        location
        actionToBeTaken
        type
        personalReportNo
        deptHead
        budgetClerk
        budgetManager
        executiveSecretary
        executiveManagement
        submited_by
        created_by
        hrTechnician
        executivedirelemId
        assignelemorsec
        psayesorno
        actionDate
        actionItem
        actionPage
        referenceNo
        isDelete
        isArchived
        isArchivedUsers
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getUserAppsPermission = /* GraphQL */ `
  query GetUserAppsPermission($id: ID!) {
    getUserAppsPermission(id: $id) {
      id
      AppId
      UserId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listUserAppsPermissions = /* GraphQL */ `
  query ListUserAppsPermissions(
    $filter: ModelUserAppsPermissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserAppsPermissions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        AppId
        UserId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncUserAppsPermissions = /* GraphQL */ `
  query SyncUserAppsPermissions(
    $filter: ModelUserAppsPermissionFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncUserAppsPermissions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        AppId
        UserId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getPSATransactionCycle = /* GraphQL */ `
  query GetPSATransactionCycle($id: ID!) {
    getPSATransactionCycle(id: $id) {
      id
      report_Id
      from_Employee_Id
      to_Employee_Id
      status
      isApproved
      remark
      date
      signature_File_Path
      dateTime
      approver_level
      designation
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listPSATransactionCycles = /* GraphQL */ `
  query ListPSATransactionCycles(
    $filter: ModelPSATransactionCycleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPSATransactionCycles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        report_Id
        from_Employee_Id
        to_Employee_Id
        status
        isApproved
        remark
        date
        signature_File_Path
        dateTime
        approver_level
        designation
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncPSATransactionCycles = /* GraphQL */ `
  query SyncPSATransactionCycles(
    $filter: ModelPSATransactionCycleFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncPSATransactionCycles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        report_Id
        from_Employee_Id
        to_Employee_Id
        status
        isApproved
        remark
        date
        signature_File_Path
        dateTime
        approver_level
        designation
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getPSAParty = /* GraphQL */ `
  query GetPSAParty($id: ID!) {
    getPSAParty(id: $id) {
      id
      party
      pocName
      pocNumber
      email
      clientId
      employerID
      ssn
      typeBE
      license
      state
      city
      address
      zip
      psaConsultantId
      title
      filename
      filename2
      strs
      calpers
      w9File
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listPSAParties = /* GraphQL */ `
  query ListPSAParties(
    $filter: ModelPSAPartyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPSAParties(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        party
        pocName
        pocNumber
        email
        clientId
        employerID
        ssn
        typeBE
        license
        state
        city
        address
        zip
        psaConsultantId
        title
        filename
        filename2
        strs
        calpers
        w9File
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncPSAParties = /* GraphQL */ `
  query SyncPSAParties(
    $filter: ModelPSAPartyFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncPSAParties(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        party
        pocName
        pocNumber
        email
        clientId
        employerID
        ssn
        typeBE
        license
        state
        city
        address
        zip
        psaConsultantId
        title
        filename
        filename2
        strs
        calpers
        w9File
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getPSAConsultant = /* GraphQL */ `
  query GetPSAConsultant($id: ID!) {
    getPSAConsultant(id: $id) {
      id
      assignmentTitle
      department
      agreementDate
      amount
      effectiveDate
      expireDate
      reviewDate
      notifyDays
      submittedTo
      accountNo
      dateofboard
      boardItem
      pageItem
      services
      budgetClerk
      hrConsultant
      executive
      hrexecutive
      psaEmail
      filename
      notes
      otherRemark
      status
      otp
      createdBy
      businessEntity
      addendum
      purchaseOrderNo
      addendumNo
      referenceNo
      submittedCompletedFormTo
      budgetManager
      dateOfApprove
      isSoftDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listPSAConsultants = /* GraphQL */ `
  query ListPSAConsultants(
    $filter: ModelPSAConsultantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPSAConsultants(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        assignmentTitle
        department
        agreementDate
        amount
        effectiveDate
        expireDate
        reviewDate
        notifyDays
        submittedTo
        accountNo
        dateofboard
        boardItem
        pageItem
        services
        budgetClerk
        hrConsultant
        executive
        hrexecutive
        psaEmail
        filename
        notes
        otherRemark
        status
        otp
        createdBy
        businessEntity
        addendum
        purchaseOrderNo
        addendumNo
        referenceNo
        submittedCompletedFormTo
        budgetManager
        dateOfApprove
        isSoftDelete
        isArchived
        isArchivedUsers
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncPSAConsultants = /* GraphQL */ `
  query SyncPSAConsultants(
    $filter: ModelPSAConsultantFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncPSAConsultants(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        assignmentTitle
        department
        agreementDate
        amount
        effectiveDate
        expireDate
        reviewDate
        notifyDays
        submittedTo
        accountNo
        dateofboard
        boardItem
        pageItem
        services
        budgetClerk
        hrConsultant
        executive
        hrexecutive
        psaEmail
        filename
        notes
        otherRemark
        status
        otp
        createdBy
        businessEntity
        addendum
        purchaseOrderNo
        addendumNo
        referenceNo
        submittedCompletedFormTo
        budgetManager
        dateOfApprove
        isSoftDelete
        isArchived
        isArchivedUsers
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getStipendTransactionCycle = /* GraphQL */ `
  query GetStipendTransactionCycle($id: ID!) {
    getStipendTransactionCycle(id: $id) {
      id
      report_Id
      from_Employee_Id
      to_Employee_Id
      status
      isApproved
      remark
      date
      signature_File_Path
      ccEmail
      rejectedBy
      submittedDate
      toEmployeeDesignation
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listStipendTransactionCycles = /* GraphQL */ `
  query ListStipendTransactionCycles(
    $filter: ModelStipendTransactionCycleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStipendTransactionCycles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        report_Id
        from_Employee_Id
        to_Employee_Id
        status
        isApproved
        remark
        date
        signature_File_Path
        ccEmail
        rejectedBy
        submittedDate
        toEmployeeDesignation
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncStipendTransactionCycles = /* GraphQL */ `
  query SyncStipendTransactionCycles(
    $filter: ModelStipendTransactionCycleFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncStipendTransactionCycles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        report_Id
        from_Employee_Id
        to_Employee_Id
        status
        isApproved
        remark
        date
        signature_File_Path
        ccEmail
        rejectedBy
        submittedDate
        toEmployeeDesignation
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getNotificationReadTable = /* GraphQL */ `
  query GetNotificationReadTable($id: ID!) {
    getNotificationReadTable(id: $id) {
      id
      read_id
      notification_id
      user_id
      read_at
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listNotificationReadTables = /* GraphQL */ `
  query ListNotificationReadTables(
    $filter: ModelNotificationReadTableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNotificationReadTables(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        read_id
        notification_id
        user_id
        read_at
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncNotificationReadTables = /* GraphQL */ `
  query SyncNotificationReadTables(
    $filter: ModelNotificationReadTableFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncNotificationReadTables(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        read_id
        notification_id
        user_id
        read_at
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getNotificationTable = /* GraphQL */ `
  query GetNotificationTable($id: ID!) {
    getNotificationTable(id: $id) {
      id
      notification_type
      user_id
      source_id
      source_typ
      message
      created_at
      AppId
      subject
      read_at
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listNotificationTables = /* GraphQL */ `
  query ListNotificationTables(
    $filter: ModelNotificationTableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNotificationTables(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        notification_type
        user_id
        source_id
        source_typ
        message
        created_at
        AppId
        subject
        read_at
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncNotificationTables = /* GraphQL */ `
  query SyncNotificationTables(
    $filter: ModelNotificationTableFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncNotificationTables(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        notification_type
        user_id
        source_id
        source_typ
        message
        created_at
        AppId
        subject
        read_at
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getCertificatedSubRequestTransactionCycle = /* GraphQL */ `
  query GetCertificatedSubRequestTransactionCycle($id: ID!) {
    getCertificatedSubRequestTransactionCycle(id: $id) {
      id
      reportId
      from_Employee_Id
      to_Employee_Id
      status
      isApproved
      remark
      approver_level
      signature_File_Path
      customUpdatedAt
      approverLevel
      toEmpDesignation
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listCertificatedSubRequestTransactionCycles = /* GraphQL */ `
  query ListCertificatedSubRequestTransactionCycles(
    $filter: ModelCertificatedSubRequestTransactionCycleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCertificatedSubRequestTransactionCycles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reportId
        from_Employee_Id
        to_Employee_Id
        status
        isApproved
        remark
        approver_level
        signature_File_Path
        customUpdatedAt
        approverLevel
        toEmpDesignation
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncCertificatedSubRequestTransactionCycles = /* GraphQL */ `
  query SyncCertificatedSubRequestTransactionCycles(
    $filter: ModelCertificatedSubRequestTransactionCycleFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncCertificatedSubRequestTransactionCycles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        reportId
        from_Employee_Id
        to_Employee_Id
        status
        isApproved
        remark
        approver_level
        signature_File_Path
        customUpdatedAt
        approverLevel
        toEmpDesignation
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getPersonalActionForm = /* GraphQL */ `
  query GetPersonalActionForm($id: ID!) {
    getPersonalActionForm(id: $id) {
      id
      employeeId
      employeeName
      positionTitle
      effectiveDates
      salaryRate
      rateofPay
      reason
      fundingSource
      accountNo
      budgetCode
      formId
      effectiveDatesTo
      effectiveDatesFrom
      positionTitleTo
      positionTitleFrom
      formTitle
      boardMeetingDate
      location
      actionToBeTaken
      type
      personalReportNo
      deptHead
      budgetClerk
      budgetManager
      executiveSecretary
      executiveManagement
      created_by
      submited_by
      isArchivedUsers
      toEmpDesignation
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listPersonalActionForms = /* GraphQL */ `
  query ListPersonalActionForms(
    $filter: ModelPersonalActionFormFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPersonalActionForms(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        employeeName
        positionTitle
        effectiveDates
        salaryRate
        rateofPay
        reason
        fundingSource
        accountNo
        budgetCode
        formId
        effectiveDatesTo
        effectiveDatesFrom
        positionTitleTo
        positionTitleFrom
        formTitle
        boardMeetingDate
        location
        actionToBeTaken
        type
        personalReportNo
        deptHead
        budgetClerk
        budgetManager
        executiveSecretary
        executiveManagement
        created_by
        submited_by
        isArchivedUsers
        toEmpDesignation
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncPersonalActionForms = /* GraphQL */ `
  query SyncPersonalActionForms(
    $filter: ModelPersonalActionFormFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncPersonalActionForms(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        employeeId
        employeeName
        positionTitle
        effectiveDates
        salaryRate
        rateofPay
        reason
        fundingSource
        accountNo
        budgetCode
        formId
        effectiveDatesTo
        effectiveDatesFrom
        positionTitleTo
        positionTitleFrom
        formTitle
        boardMeetingDate
        location
        actionToBeTaken
        type
        personalReportNo
        deptHead
        budgetClerk
        budgetManager
        executiveSecretary
        executiveManagement
        created_by
        submited_by
        isArchivedUsers
        toEmpDesignation
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getHandbookAssignee = /* GraphQL */ `
  query GetHandbookAssignee($id: ID!) {
    getHandbookAssignee(id: $id) {
      id
      handbook_id
      emp_id
      status
      acknowledge_date
      due_date
      created_by
      created_date
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listHandbookAssignees = /* GraphQL */ `
  query ListHandbookAssignees(
    $filter: ModelHandbookAssigneeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listHandbookAssignees(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        handbook_id
        emp_id
        status
        acknowledge_date
        due_date
        created_by
        created_date
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncHandbookAssignees = /* GraphQL */ `
  query SyncHandbookAssignees(
    $filter: ModelHandbookAssigneeFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncHandbookAssignees(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        handbook_id
        emp_id
        status
        acknowledge_date
        due_date
        created_by
        created_date
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getHandbook = /* GraphQL */ `
  query GetHandbook($id: ID!) {
    getHandbook(id: $id) {
      id
      handbook_name
      description
      file_path
      created_date
      created_by
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listHandbooks = /* GraphQL */ `
  query ListHandbooks(
    $filter: ModelHandbookFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listHandbooks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        handbook_name
        description
        file_path
        created_date
        created_by
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncHandbooks = /* GraphQL */ `
  query SyncHandbooks(
    $filter: ModelHandbookFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncHandbooks(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        handbook_name
        description
        file_path
        created_date
        created_by
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getCertificatedSubRequestFundingAccountDetails = /* GraphQL */ `
  query GetCertificatedSubRequestFundingAccountDetails($id: ID!) {
    getCertificatedSubRequestFundingAccountDetails(id: $id) {
      id
      reportId
      fundingAccountTypeId
      accountNumber
      noteIfSpecify
      remarks
      percentage
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listCertificatedSubRequestFundingAccountDetails = /* GraphQL */ `
  query ListCertificatedSubRequestFundingAccountDetails(
    $filter: ModelCertificatedSubRequestFundingAccountDetailsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCertificatedSubRequestFundingAccountDetails(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reportId
        fundingAccountTypeId
        accountNumber
        noteIfSpecify
        remarks
        percentage
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncCertificatedSubRequestFundingAccountDetails = /* GraphQL */ `
  query SyncCertificatedSubRequestFundingAccountDetails(
    $filter: ModelCertificatedSubRequestFundingAccountDetailsFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncCertificatedSubRequestFundingAccountDetails(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        reportId
        fundingAccountTypeId
        accountNumber
        noteIfSpecify
        remarks
        percentage
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getFundingAccountType = /* GraphQL */ `
  query GetFundingAccountType($id: ID!) {
    getFundingAccountType(id: $id) {
      id
      fundingAccountType
      isSpecify
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listFundingAccountTypes = /* GraphQL */ `
  query ListFundingAccountTypes(
    $filter: ModelFundingAccountTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFundingAccountTypes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fundingAccountType
        isSpecify
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncFundingAccountTypes = /* GraphQL */ `
  query SyncFundingAccountTypes(
    $filter: ModelFundingAccountTypeFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncFundingAccountTypes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        fundingAccountType
        isSpecify
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getCertificatedSubRequestSpecificTeacherDates = /* GraphQL */ `
  query GetCertificatedSubRequestSpecificTeacherDates($id: ID!) {
    getCertificatedSubRequestSpecificTeacherDates(id: $id) {
      id
      teacherId
      date
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listCertificatedSubRequestSpecificTeacherDates = /* GraphQL */ `
  query ListCertificatedSubRequestSpecificTeacherDates(
    $filter: ModelCertificatedSubRequestSpecificTeacherDatesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCertificatedSubRequestSpecificTeacherDates(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        teacherId
        date
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncCertificatedSubRequestSpecificTeacherDates = /* GraphQL */ `
  query SyncCertificatedSubRequestSpecificTeacherDates(
    $filter: ModelCertificatedSubRequestSpecificTeacherDatesFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncCertificatedSubRequestSpecificTeacherDates(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        teacherId
        date
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getCertificatedSubRequestTeacherData = /* GraphQL */ `
  query GetCertificatedSubRequestTeacherData($id: ID!) {
    getCertificatedSubRequestTeacherData(id: $id) {
      id
      reportId
      teacherId
      indicateIf
      gradeOrSubject
      note
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listCertificatedSubRequestTeacherData = /* GraphQL */ `
  query ListCertificatedSubRequestTeacherData(
    $filter: ModelCertificatedSubRequestTeacherDataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCertificatedSubRequestTeacherData(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reportId
        teacherId
        indicateIf
        gradeOrSubject
        note
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncCertificatedSubRequestTeacherData = /* GraphQL */ `
  query SyncCertificatedSubRequestTeacherData(
    $filter: ModelCertificatedSubRequestTeacherDataFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncCertificatedSubRequestTeacherData(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        reportId
        teacherId
        indicateIf
        gradeOrSubject
        note
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getCertificatedSubInitiateRequest = /* GraphQL */ `
  query GetCertificatedSubInitiateRequest($id: ID!) {
    getCertificatedSubInitiateRequest(id: $id) {
      id
      schoolOrDeptId
      reportDate
      purposeOfReport
      status
      submittedBy
      submittedOn
      firstApproverId
      secondApproverId
      payrollId
      thirdApproverId
      assighmentTitle
      isSoftDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listCertificatedSubInitiateRequests = /* GraphQL */ `
  query ListCertificatedSubInitiateRequests(
    $filter: ModelCertificatedSubInitiateRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCertificatedSubInitiateRequests(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        schoolOrDeptId
        reportDate
        purposeOfReport
        status
        submittedBy
        submittedOn
        firstApproverId
        secondApproverId
        payrollId
        thirdApproverId
        assighmentTitle
        isSoftDelete
        isArchived
        isArchivedUsers
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncCertificatedSubInitiateRequests = /* GraphQL */ `
  query SyncCertificatedSubInitiateRequests(
    $filter: ModelCertificatedSubInitiateRequestFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncCertificatedSubInitiateRequests(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        schoolOrDeptId
        reportDate
        purposeOfReport
        status
        submittedBy
        submittedOn
        firstApproverId
        secondApproverId
        payrollId
        thirdApproverId
        assighmentTitle
        isSoftDelete
        isArchived
        isArchivedUsers
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getStipendAssignments = /* GraphQL */ `
  query GetStipendAssignments($id: ID!) {
    getStipendAssignments(id: $id) {
      id
      stipendMasterId
      name
      amount
      isSplit
      splitText
      isExtraCurricular
      isDeptChair
      noOfEmployee
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listStipendAssignments = /* GraphQL */ `
  query ListStipendAssignments(
    $filter: ModelStipendAssignmentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStipendAssignments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        stipendMasterId
        name
        amount
        isSplit
        splitText
        isExtraCurricular
        isDeptChair
        noOfEmployee
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncStipendAssignments = /* GraphQL */ `
  query SyncStipendAssignments(
    $filter: ModelStipendAssignmentsFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncStipendAssignments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        stipendMasterId
        name
        amount
        isSplit
        splitText
        isExtraCurricular
        isDeptChair
        noOfEmployee
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getDepartmentTypeMaster = /* GraphQL */ `
  query GetDepartmentTypeMaster($id: ID!) {
    getDepartmentTypeMaster(id: $id) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listDepartmentTypeMasters = /* GraphQL */ `
  query ListDepartmentTypeMasters(
    $filter: ModelDepartmentTypeMasterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDepartmentTypeMasters(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncDepartmentTypeMasters = /* GraphQL */ `
  query SyncDepartmentTypeMasters(
    $filter: ModelDepartmentTypeMasterFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncDepartmentTypeMasters(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getStipendTypeMaster = /* GraphQL */ `
  query GetStipendTypeMaster($id: ID!) {
    getStipendTypeMaster(id: $id) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listStipendTypeMasters = /* GraphQL */ `
  query ListStipendTypeMasters(
    $filter: ModelStipendTypeMasterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStipendTypeMasters(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncStipendTypeMasters = /* GraphQL */ `
  query SyncStipendTypeMasters(
    $filter: ModelStipendTypeMasterFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncStipendTypeMasters(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getSemisterMaster = /* GraphQL */ `
  query GetSemisterMaster($id: ID!) {
    getSemisterMaster(id: $id) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listSemisterMasters = /* GraphQL */ `
  query ListSemisterMasters(
    $filter: ModelSemisterMasterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSemisterMasters(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncSemisterMasters = /* GraphQL */ `
  query SyncSemisterMasters(
    $filter: ModelSemisterMasterFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSemisterMasters(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getYearMaster = /* GraphQL */ `
  query GetYearMaster($id: ID!) {
    getYearMaster(id: $id) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listYearMasters = /* GraphQL */ `
  query ListYearMasters(
    $filter: ModelYearMasterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listYearMasters(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncYearMasters = /* GraphQL */ `
  query SyncYearMasters(
    $filter: ModelYearMasterFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncYearMasters(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getStipendMaster = /* GraphQL */ `
  query GetStipendMaster($id: ID!) {
    getStipendMaster(id: $id) {
      id
      employeeId
      schoolId
      schoolYearId
      semisterId
      stipendAssignmentId
      selfAssignment
      departmentTypeId
      peopleCountInDepartment
      status
      createdBy
      isElementaryStipend
      isMiddleStipend
      isHighStipend
      isDepartmentStipend
      isHeadStipend
      principalId
      hrTechI
      executiveManagerId
      statusStipend
      title
      updatedBy
      remark
      rejectedBy
      isSoftDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listStipendMasters = /* GraphQL */ `
  query ListStipendMasters(
    $filter: ModelStipendMasterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStipendMasters(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        employeeId
        schoolId
        schoolYearId
        semisterId
        stipendAssignmentId
        selfAssignment
        departmentTypeId
        peopleCountInDepartment
        status
        createdBy
        isElementaryStipend
        isMiddleStipend
        isHighStipend
        isDepartmentStipend
        isHeadStipend
        principalId
        hrTechI
        executiveManagerId
        statusStipend
        title
        updatedBy
        remark
        rejectedBy
        isSoftDelete
        isArchived
        isArchivedUsers
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncStipendMasters = /* GraphQL */ `
  query SyncStipendMasters(
    $filter: ModelStipendMasterFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncStipendMasters(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        employeeId
        schoolId
        schoolYearId
        semisterId
        stipendAssignmentId
        selfAssignment
        departmentTypeId
        peopleCountInDepartment
        status
        createdBy
        isElementaryStipend
        isMiddleStipend
        isHighStipend
        isDepartmentStipend
        isHeadStipend
        principalId
        hrTechI
        executiveManagerId
        statusStipend
        title
        updatedBy
        remark
        rejectedBy
        isSoftDelete
        isArchived
        isArchivedUsers
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getUntitledModel = /* GraphQL */ `
  query GetUntitledModel($id: ID!) {
    getUntitledModel(id: $id) {
      id
      untitledfield
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listUntitledModels = /* GraphQL */ `
  query ListUntitledModels(
    $filter: ModelUntitledModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUntitledModels(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        untitledfield
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncUntitledModels = /* GraphQL */ `
  query SyncUntitledModels(
    $filter: ModelUntitledModelFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncUntitledModels(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        untitledfield
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getClassifiedSubInitiateRequest = /* GraphQL */ `
  query GetClassifiedSubInitiateRequest($id: ID!) {
    getClassifiedSubInitiateRequest(id: $id) {
      id
      assignmentTitle
      classification
      selectedEmployeeId
      fromDate
      toDate
      typeOfSubReqOrobjCode
      totalWorkingHours
      startTime
      endTime
      locationId
      reasonForAbsenceRequest
      substitude
      confirmed
      firstApproverId
      status
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listClassifiedSubInitiateRequests = /* GraphQL */ `
  query ListClassifiedSubInitiateRequests(
    $filter: ModelClassifiedSubInitiateRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listClassifiedSubInitiateRequests(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        assignmentTitle
        classification
        selectedEmployeeId
        fromDate
        toDate
        typeOfSubReqOrobjCode
        totalWorkingHours
        startTime
        endTime
        locationId
        reasonForAbsenceRequest
        substitude
        confirmed
        firstApproverId
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncClassifiedSubInitiateRequests = /* GraphQL */ `
  query SyncClassifiedSubInitiateRequests(
    $filter: ModelClassifiedSubInitiateRequestFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncClassifiedSubInitiateRequests(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        assignmentTitle
        classification
        selectedEmployeeId
        fromDate
        toDate
        typeOfSubReqOrobjCode
        totalWorkingHours
        startTime
        endTime
        locationId
        reasonForAbsenceRequest
        substitude
        confirmed
        firstApproverId
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getEmployeeHandbook = /* GraphQL */ `
  query GetEmployeeHandbook($id: ID!) {
    getEmployeeHandbook(id: $id) {
      id
      EmployeeName
      EmployeeId
      dateHandbookSend
      dateofAcknowledge
      status
      handbookName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listEmployeeHandbooks = /* GraphQL */ `
  query ListEmployeeHandbooks(
    $filter: ModelEmployeeHandbookFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmployeeHandbooks(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        EmployeeName
        EmployeeId
        dateHandbookSend
        dateofAcknowledge
        status
        handbookName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncEmployeeHandbooks = /* GraphQL */ `
  query SyncEmployeeHandbooks(
    $filter: ModelEmployeeHandbookFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncEmployeeHandbooks(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        EmployeeName
        EmployeeId
        dateHandbookSend
        dateofAcknowledge
        status
        handbookName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getSubstituteCertificateRequestTransactionCycle = /* GraphQL */ `
  query GetSubstituteCertificateRequestTransactionCycle($id: ID!) {
    getSubstituteCertificateRequestTransactionCycle(id: $id) {
      id
      reportId
      fromEmployeeId
      toEmployeeId
      status
      isApproved
      remark
      date
      approver_level
      customUpdatedAt
      toEmpDesignation
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listSubstituteCertificateRequestTransactionCycles = /* GraphQL */ `
  query ListSubstituteCertificateRequestTransactionCycles(
    $filter: ModelSubstituteCertificateRequestTransactionCycleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubstituteCertificateRequestTransactionCycles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reportId
        fromEmployeeId
        toEmployeeId
        status
        isApproved
        remark
        date
        approver_level
        customUpdatedAt
        toEmpDesignation
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncSubstituteCertificateRequestTransactionCycles = /* GraphQL */ `
  query SyncSubstituteCertificateRequestTransactionCycles(
    $filter: ModelSubstituteCertificateRequestTransactionCycleFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSubstituteCertificateRequestTransactionCycles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        reportId
        fromEmployeeId
        toEmployeeId
        status
        isApproved
        remark
        date
        approver_level
        customUpdatedAt
        toEmpDesignation
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getSubstituteCertificateRequestAccountNoIDs = /* GraphQL */ `
  query GetSubstituteCertificateRequestAccountNoIDs($id: ID!) {
    getSubstituteCertificateRequestAccountNoIDs(id: $id) {
      id
      substituteCertificateRequestId
      accountNumber
      percentage
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listSubstituteCertificateRequestAccountNoIDs = /* GraphQL */ `
  query ListSubstituteCertificateRequestAccountNoIDs(
    $filter: ModelSubstituteCertificateRequestAccountNoIDsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubstituteCertificateRequestAccountNoIDs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        substituteCertificateRequestId
        accountNumber
        percentage
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncSubstituteCertificateRequestAccountNoIDs = /* GraphQL */ `
  query SyncSubstituteCertificateRequestAccountNoIDs(
    $filter: ModelSubstituteCertificateRequestAccountNoIDsFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSubstituteCertificateRequestAccountNoIDs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        substituteCertificateRequestId
        accountNumber
        percentage
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getSubstituteCertificateRequest = /* GraphQL */ `
  query GetSubstituteCertificateRequest($id: ID!) {
    getSubstituteCertificateRequest(id: $id) {
      id
      assignmentTitle
      classification
      employeeCodeId
      fromDate
      toDate
      typeOfSub
      locationId
      reasonForAbsenceRequest
      substitudeName
      isConfirmed
      principleDepartmentHeadString
      createdBy
      CreatedByDateTime
      fromTime
      endTime
      budgetApprover
      payrollHr
      totalWorkingHours
      budgetManager
      isSoftDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listSubstituteCertificateRequests = /* GraphQL */ `
  query ListSubstituteCertificateRequests(
    $filter: ModelSubstituteCertificateRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubstituteCertificateRequests(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        assignmentTitle
        classification
        employeeCodeId
        fromDate
        toDate
        typeOfSub
        locationId
        reasonForAbsenceRequest
        substitudeName
        isConfirmed
        principleDepartmentHeadString
        createdBy
        CreatedByDateTime
        fromTime
        endTime
        budgetApprover
        payrollHr
        totalWorkingHours
        budgetManager
        isSoftDelete
        isArchived
        isArchivedUsers
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncSubstituteCertificateRequests = /* GraphQL */ `
  query SyncSubstituteCertificateRequests(
    $filter: ModelSubstituteCertificateRequestFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSubstituteCertificateRequests(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        assignmentTitle
        classification
        employeeCodeId
        fromDate
        toDate
        typeOfSub
        locationId
        reasonForAbsenceRequest
        substitudeName
        isConfirmed
        principleDepartmentHeadString
        createdBy
        CreatedByDateTime
        fromTime
        endTime
        budgetApprover
        payrollHr
        totalWorkingHours
        budgetManager
        isSoftDelete
        isArchived
        isArchivedUsers
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getCertifiedAdminReportsLog = /* GraphQL */ `
  query GetCertifiedAdminReportsLog($id: ID!) {
    getCertifiedAdminReportsLog(id: $id) {
      id
      report_id
      comment
      date_and_time
      user_id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listCertifiedAdminReportsLogs = /* GraphQL */ `
  query ListCertifiedAdminReportsLogs(
    $filter: ModelCertifiedAdminReportsLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCertifiedAdminReportsLogs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        report_id
        comment
        date_and_time
        user_id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncCertifiedAdminReportsLogs = /* GraphQL */ `
  query SyncCertifiedAdminReportsLogs(
    $filter: ModelCertifiedAdminReportsLogFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncCertifiedAdminReportsLogs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        report_id
        comment
        date_and_time
        user_id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getCertificatedAdminWeeklyAbsenceReportEmployeeDetails = /* GraphQL */ `
  query GetCertificatedAdminWeeklyAbsenceReportEmployeeDetails($id: ID!) {
    getCertificatedAdminWeeklyAbsenceReportEmployeeDetails(id: $id) {
      id
      Certificated_Admin_Weekly_Absence_Report_Employee_id
      absent_code_id
      substitute_emp_id
      is_full_day
      partial_hour
      partial_min
      absent_date
      employee_type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listCertificatedAdminWeeklyAbsenceReportEmployeeDetails = /* GraphQL */ `
  query ListCertificatedAdminWeeklyAbsenceReportEmployeeDetails(
    $filter: ModelCertificatedAdminWeeklyAbsenceReportEmployeeDetailsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCertificatedAdminWeeklyAbsenceReportEmployeeDetails(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        Certificated_Admin_Weekly_Absence_Report_Employee_id
        absent_code_id
        substitute_emp_id
        is_full_day
        partial_hour
        partial_min
        absent_date
        employee_type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncCertificatedAdminWeeklyAbsenceReportEmployeeDetails = /* GraphQL */ `
  query SyncCertificatedAdminWeeklyAbsenceReportEmployeeDetails(
    $filter: ModelCertificatedAdminWeeklyAbsenceReportEmployeeDetailsFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncCertificatedAdminWeeklyAbsenceReportEmployeeDetails(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        Certificated_Admin_Weekly_Absence_Report_Employee_id
        absent_code_id
        substitute_emp_id
        is_full_day
        partial_hour
        partial_min
        absent_date
        employee_type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getCertificatedAdminWeeklyAbsenceReportEmployee = /* GraphQL */ `
  query GetCertificatedAdminWeeklyAbsenceReportEmployee($id: ID!) {
    getCertificatedAdminWeeklyAbsenceReportEmployee(id: $id) {
      id
      Certificated_Admin_Weekly_Absence_Report_id
      employee_id
      employee_type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listCertificatedAdminWeeklyAbsenceReportEmployees = /* GraphQL */ `
  query ListCertificatedAdminWeeklyAbsenceReportEmployees(
    $filter: ModelCertificatedAdminWeeklyAbsenceReportEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCertificatedAdminWeeklyAbsenceReportEmployees(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        Certificated_Admin_Weekly_Absence_Report_id
        employee_id
        employee_type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncCertificatedAdminWeeklyAbsenceReportEmployees = /* GraphQL */ `
  query SyncCertificatedAdminWeeklyAbsenceReportEmployees(
    $filter: ModelCertificatedAdminWeeklyAbsenceReportEmployeeFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncCertificatedAdminWeeklyAbsenceReportEmployees(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        Certificated_Admin_Weekly_Absence_Report_id
        employee_id
        employee_type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getCertificatedAdminWeeklyAbsenceReport = /* GraphQL */ `
  query GetCertificatedAdminWeeklyAbsenceReport($id: ID!) {
    getCertificatedAdminWeeklyAbsenceReport(id: $id) {
      id
      status
      school_id
      from_date
      to_date
      status_date_time
      approver_status
      approver_by
      approver_date_time
      payroll_status
      payroll_by
      payroll_date_time
      approver_remark
      payroll_remark
      l1_authority
      l2_authority
      user_id
      comment
      customUpdatedAt
      isSoftDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listCertificatedAdminWeeklyAbsenceReports = /* GraphQL */ `
  query ListCertificatedAdminWeeklyAbsenceReports(
    $filter: ModelCertificatedAdminWeeklyAbsenceReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCertificatedAdminWeeklyAbsenceReports(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        school_id
        from_date
        to_date
        status_date_time
        approver_status
        approver_by
        approver_date_time
        payroll_status
        payroll_by
        payroll_date_time
        approver_remark
        payroll_remark
        l1_authority
        l2_authority
        user_id
        comment
        customUpdatedAt
        isSoftDelete
        isArchived
        isArchivedUsers
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncCertificatedAdminWeeklyAbsenceReports = /* GraphQL */ `
  query SyncCertificatedAdminWeeklyAbsenceReports(
    $filter: ModelCertificatedAdminWeeklyAbsenceReportFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncCertificatedAdminWeeklyAbsenceReports(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        status
        school_id
        from_date
        to_date
        status_date_time
        approver_status
        approver_by
        approver_date_time
        payroll_status
        payroll_by
        payroll_date_time
        approver_remark
        payroll_remark
        l1_authority
        l2_authority
        user_id
        comment
        customUpdatedAt
        isSoftDelete
        isArchived
        isArchivedUsers
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getTimeReportTransactionCycle = /* GraphQL */ `
  query GetTimeReportTransactionCycle($id: ID!) {
    getTimeReportTransactionCycle(id: $id) {
      id
      report_Id
      from_Employee_Id
      to_Employee_Id
      status
      isApproved
      remark
      date
      approver_level
      customUpdatedAt
      toEmpDesignation
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listTimeReportTransactionCycles = /* GraphQL */ `
  query ListTimeReportTransactionCycles(
    $filter: ModelTimeReportTransactionCycleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTimeReportTransactionCycles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        report_Id
        from_Employee_Id
        to_Employee_Id
        status
        isApproved
        remark
        date
        approver_level
        customUpdatedAt
        toEmpDesignation
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncTimeReportTransactionCycles = /* GraphQL */ `
  query SyncTimeReportTransactionCycles(
    $filter: ModelTimeReportTransactionCycleFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncTimeReportTransactionCycles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        report_Id
        from_Employee_Id
        to_Employee_Id
        status
        isApproved
        remark
        date
        approver_level
        customUpdatedAt
        toEmpDesignation
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getEmployeeType = /* GraphQL */ `
  query GetEmployeeType($id: ID!) {
    getEmployeeType(id: $id) {
      id
      untitledfield
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listEmployeeTypes = /* GraphQL */ `
  query ListEmployeeTypes(
    $filter: ModelEmployeeTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmployeeTypes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        untitledfield
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncEmployeeTypes = /* GraphQL */ `
  query SyncEmployeeTypes(
    $filter: ModelEmployeeTypeFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncEmployeeTypes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        untitledfield
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getTimeReportEmployeeDetails = /* GraphQL */ `
  query GetTimeReportEmployeeDetails($id: ID!) {
    getTimeReportEmployeeDetails(id: $id) {
      id
      time_Report_Employee_Id
      date
      totalHours
      totalMin
      totalHoursAndMinDisplay
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listTimeReportEmployeeDetails = /* GraphQL */ `
  query ListTimeReportEmployeeDetails(
    $filter: ModelTimeReportEmployeeDetailsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTimeReportEmployeeDetails(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        time_Report_Employee_Id
        date
        totalHours
        totalMin
        totalHoursAndMinDisplay
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncTimeReportEmployeeDetails = /* GraphQL */ `
  query SyncTimeReportEmployeeDetails(
    $filter: ModelTimeReportEmployeeDetailsFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncTimeReportEmployeeDetails(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        time_Report_Employee_Id
        date
        totalHours
        totalMin
        totalHoursAndMinDisplay
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getTimeReportEmployee = /* GraphQL */ `
  query GetTimeReportEmployee($id: ID!) {
    getTimeReportEmployee(id: $id) {
      id
      employee_Id
      time_Report_Id
      pay_Rate
      totalEmployeeWorkingHours
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listTimeReportEmployees = /* GraphQL */ `
  query ListTimeReportEmployees(
    $filter: ModelTimeReportEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTimeReportEmployees(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employee_Id
        time_Report_Id
        pay_Rate
        totalEmployeeWorkingHours
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncTimeReportEmployees = /* GraphQL */ `
  query SyncTimeReportEmployees(
    $filter: ModelTimeReportEmployeeFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncTimeReportEmployees(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        employee_Id
        time_Report_Id
        pay_Rate
        totalEmployeeWorkingHours
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getTimeReportInitiateReport = /* GraphQL */ `
  query GetTimeReportInitiateReport($id: ID!) {
    getTimeReportInitiateReport(id: $id) {
      id
      school_Department_Id
      From_Date
      To_Date
      Type
      Account
      Hourly_Rate
      Daily_Rate
      Authorizing_Board_Report_Date
      First_Approveal
      Second_Approveal
      Status
      Created_By
      Created_By_Date
      payroll_id
      validator_id
      pageNo
      Notes
      rateType
      isSoftDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listTimeReportInitiateReports = /* GraphQL */ `
  query ListTimeReportInitiateReports(
    $filter: ModelTimeReportInitiateReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTimeReportInitiateReports(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        school_Department_Id
        From_Date
        To_Date
        Type
        Account
        Hourly_Rate
        Daily_Rate
        Authorizing_Board_Report_Date
        First_Approveal
        Second_Approveal
        Status
        Created_By
        Created_By_Date
        payroll_id
        validator_id
        pageNo
        Notes
        rateType
        isSoftDelete
        isArchived
        isArchivedUsers
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncTimeReportInitiateReports = /* GraphQL */ `
  query SyncTimeReportInitiateReports(
    $filter: ModelTimeReportInitiateReportFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncTimeReportInitiateReports(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        school_Department_Id
        From_Date
        To_Date
        Type
        Account
        Hourly_Rate
        Daily_Rate
        Authorizing_Board_Report_Date
        First_Approveal
        Second_Approveal
        Status
        Created_By
        Created_By_Date
        payroll_id
        validator_id
        pageNo
        Notes
        rateType
        isSoftDelete
        isArchived
        isArchivedUsers
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getSixthPeriodReportTransactionCycle = /* GraphQL */ `
  query GetSixthPeriodReportTransactionCycle($id: ID!) {
    getSixthPeriodReportTransactionCycle(id: $id) {
      id
      report_Id
      from_Employee_Id
      to_Employee_Id
      status
      isApproved
      remark
      date
      signature_File_Path
      approver_level
      customResubmitDate
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listSixthPeriodReportTransactionCycles = /* GraphQL */ `
  query ListSixthPeriodReportTransactionCycles(
    $filter: ModelSixthPeriodReportTransactionCycleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSixthPeriodReportTransactionCycles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        report_Id
        from_Employee_Id
        to_Employee_Id
        status
        isApproved
        remark
        date
        signature_File_Path
        approver_level
        customResubmitDate
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncSixthPeriodReportTransactionCycles = /* GraphQL */ `
  query SyncSixthPeriodReportTransactionCycles(
    $filter: ModelSixthPeriodReportTransactionCycleFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSixthPeriodReportTransactionCycles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        report_Id
        from_Employee_Id
        to_Employee_Id
        status
        isApproved
        remark
        date
        signature_File_Path
        approver_level
        customResubmitDate
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getSubject = /* GraphQL */ `
  query GetSubject($id: ID!) {
    getSubject(id: $id) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listSubjects = /* GraphQL */ `
  query ListSubjects(
    $filter: ModelSubjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubjects(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncSubjects = /* GraphQL */ `
  query SyncSubjects(
    $filter: ModelSubjectFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSubjects(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getSixthPeriodAssignmentInitiateReport = /* GraphQL */ `
  query GetSixthPeriodAssignmentInitiateReport($id: ID!) {
    getSixthPeriodAssignmentInitiateReport(id: $id) {
      id
      assignment_title
      employee_id
      assighment_at
      from_date
      to_date
      subject_area
      total_staffing_allocation
      account_charged
      current_fte_utilized
      submited_by
      submited_at
      created_by
      particular_emp_reporting_manager
      budgetClerkId
      budgetManagerId
      hrDirectorI
      payrollId
      editable
      isSoftDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listSixthPeriodAssignmentInitiateReports = /* GraphQL */ `
  query ListSixthPeriodAssignmentInitiateReports(
    $filter: ModelSixthPeriodAssignmentInitiateReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSixthPeriodAssignmentInitiateReports(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        assignment_title
        employee_id
        assighment_at
        from_date
        to_date
        subject_area
        total_staffing_allocation
        account_charged
        current_fte_utilized
        submited_by
        submited_at
        created_by
        particular_emp_reporting_manager
        budgetClerkId
        budgetManagerId
        hrDirectorI
        payrollId
        editable
        isSoftDelete
        isArchived
        isArchivedUsers
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncSixthPeriodAssignmentInitiateReports = /* GraphQL */ `
  query SyncSixthPeriodAssignmentInitiateReports(
    $filter: ModelSixthPeriodAssignmentInitiateReportFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSixthPeriodAssignmentInitiateReports(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        assignment_title
        employee_id
        assighment_at
        from_date
        to_date
        subject_area
        total_staffing_allocation
        account_charged
        current_fte_utilized
        submited_by
        submited_at
        created_by
        particular_emp_reporting_manager
        budgetClerkId
        budgetManagerId
        hrDirectorI
        payrollId
        editable
        isSoftDelete
        isArchived
        isArchivedUsers
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getReportsLog = /* GraphQL */ `
  query GetReportsLog($id: ID!) {
    getReportsLog(id: $id) {
      id
      report_id
      comment
      date_and_time
      user_id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listReportsLogs = /* GraphQL */ `
  query ListReportsLogs(
    $filter: ModelReportsLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listReportsLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        report_id
        comment
        date_and_time
        user_id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncReportsLogs = /* GraphQL */ `
  query SyncReportsLogs(
    $filter: ModelReportsLogFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncReportsLogs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        report_id
        comment
        date_and_time
        user_id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getInitiateClassifiedWeeklyAbsenceReportEmployeeDetails = /* GraphQL */ `
  query GetInitiateClassifiedWeeklyAbsenceReportEmployeeDetails($id: ID!) {
    getInitiateClassifiedWeeklyAbsenceReportEmployeeDetails(id: $id) {
      id
      initiate_classified_weekly_absence_report_employee_id
      absent_code_id
      substitute_emp_id
      is_full_day
      partial_hour
      partial_min
      absent_date
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listInitiateClassifiedWeeklyAbsenceReportEmployeeDetails = /* GraphQL */ `
  query ListInitiateClassifiedWeeklyAbsenceReportEmployeeDetails(
    $filter: ModelInitiateClassifiedWeeklyAbsenceReportEmployeeDetailsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInitiateClassifiedWeeklyAbsenceReportEmployeeDetails(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        initiate_classified_weekly_absence_report_employee_id
        absent_code_id
        substitute_emp_id
        is_full_day
        partial_hour
        partial_min
        absent_date
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncInitiateClassifiedWeeklyAbsenceReportEmployeeDetails = /* GraphQL */ `
  query SyncInitiateClassifiedWeeklyAbsenceReportEmployeeDetails(
    $filter: ModelInitiateClassifiedWeeklyAbsenceReportEmployeeDetailsFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncInitiateClassifiedWeeklyAbsenceReportEmployeeDetails(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        initiate_classified_weekly_absence_report_employee_id
        absent_code_id
        substitute_emp_id
        is_full_day
        partial_hour
        partial_min
        absent_date
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getInitiateClassifiedWeeklyAbsenceReportEmployee = /* GraphQL */ `
  query GetInitiateClassifiedWeeklyAbsenceReportEmployee($id: ID!) {
    getInitiateClassifiedWeeklyAbsenceReportEmployee(id: $id) {
      id
      initiate_classified_weekly_absence_report_id
      employee_id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listInitiateClassifiedWeeklyAbsenceReportEmployees = /* GraphQL */ `
  query ListInitiateClassifiedWeeklyAbsenceReportEmployees(
    $filter: ModelInitiateClassifiedWeeklyAbsenceReportEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInitiateClassifiedWeeklyAbsenceReportEmployees(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        initiate_classified_weekly_absence_report_id
        employee_id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncInitiateClassifiedWeeklyAbsenceReportEmployees = /* GraphQL */ `
  query SyncInitiateClassifiedWeeklyAbsenceReportEmployees(
    $filter: ModelInitiateClassifiedWeeklyAbsenceReportEmployeeFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncInitiateClassifiedWeeklyAbsenceReportEmployees(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        initiate_classified_weekly_absence_report_id
        employee_id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getUserGroups = /* GraphQL */ `
  query GetUserGroups($id: ID!) {
    getUserGroups(id: $id) {
      id
      user_id
      group_id
      lock_access
      request_type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listUserGroups = /* GraphQL */ `
  query ListUserGroups(
    $filter: ModelUserGroupsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        user_id
        group_id
        lock_access
        request_type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncUserGroups = /* GraphQL */ `
  query SyncUserGroups(
    $filter: ModelUserGroupsFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncUserGroups(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        user_id
        group_id
        lock_access
        request_type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getEmployee = /* GraphQL */ `
  query GetEmployee($id: ID!) {
    getEmployee(id: $id) {
      id
      employee_name
      employee_code
      school_id
      address_1
      address_2
      city
      zip_code
      country
      phone_no
      email
      state
      employeeType
      user_Id
      designation
      firstName
      lastName
      role
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listEmployees = /* GraphQL */ `
  query ListEmployees(
    $filter: ModelEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmployees(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        employee_name
        employee_code
        school_id
        address_1
        address_2
        city
        zip_code
        country
        phone_no
        email
        state
        employeeType
        user_Id
        designation
        firstName
        lastName
        role
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncEmployees = /* GraphQL */ `
  query SyncEmployees(
    $filter: ModelEmployeeFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncEmployees(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        employee_name
        employee_code
        school_id
        address_1
        address_2
        city
        zip_code
        country
        phone_no
        email
        state
        employeeType
        user_Id
        designation
        firstName
        lastName
        role
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getRoleAccess = /* GraphQL */ `
  query GetRoleAccess($id: ID!) {
    getRoleAccess(id: $id) {
      id
      name
      parent_id
      sort_order
      is_view_applicable
      is_add_applicable
      is_edit_applicable
      is_delete_applicable
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listRoleAccesses = /* GraphQL */ `
  query ListRoleAccesses(
    $filter: ModelRoleAccessFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRoleAccesses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        parent_id
        sort_order
        is_view_applicable
        is_add_applicable
        is_edit_applicable
        is_delete_applicable
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncRoleAccesses = /* GraphQL */ `
  query SyncRoleAccesses(
    $filter: ModelRoleAccessFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncRoleAccesses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        parent_id
        sort_order
        is_view_applicable
        is_add_applicable
        is_edit_applicable
        is_delete_applicable
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getGroups = /* GraphQL */ `
  query GetGroups($id: ID!) {
    getGroups(id: $id) {
      id
      name
      selected_users
      assigned_members_count
      is_access_locked
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listGroups = /* GraphQL */ `
  query ListGroups(
    $filter: ModelGroupsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        selected_users
        assigned_members_count
        is_access_locked
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncGroups = /* GraphQL */ `
  query SyncGroups(
    $filter: ModelGroupsFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncGroups(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        selected_users
        assigned_members_count
        is_access_locked
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getAbsentType = /* GraphQL */ `
  query GetAbsentType($id: ID!) {
    getAbsentType(id: $id) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listAbsentTypes = /* GraphQL */ `
  query ListAbsentTypes(
    $filter: ModelAbsentTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAbsentTypes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncAbsentTypes = /* GraphQL */ `
  query SyncAbsentTypes(
    $filter: ModelAbsentTypeFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncAbsentTypes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getInitiateClassifiedWeeklyAbsenceReport = /* GraphQL */ `
  query GetInitiateClassifiedWeeklyAbsenceReport($id: ID!) {
    getInitiateClassifiedWeeklyAbsenceReport(id: $id) {
      id
      user_id
      status
      school_id
      from_date
      to_date
      status_date_time
      approver_status
      approver_by
      approver_date_time
      payroll_status
      payroll_by
      payroll_date_time
      approver_remark
      payroll_remark
      l1_authority
      l2_authority
      comment
      customUpdatedAt
      isSoftDelete
      isArchived
      updatedBy
      deletedBy
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listInitiateClassifiedWeeklyAbsenceReports = /* GraphQL */ `
  query ListInitiateClassifiedWeeklyAbsenceReports(
    $filter: ModelInitiateClassifiedWeeklyAbsenceReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInitiateClassifiedWeeklyAbsenceReports(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        user_id
        status
        school_id
        from_date
        to_date
        status_date_time
        approver_status
        approver_by
        approver_date_time
        payroll_status
        payroll_by
        payroll_date_time
        approver_remark
        payroll_remark
        l1_authority
        l2_authority
        comment
        customUpdatedAt
        isSoftDelete
        isArchived
        updatedBy
        deletedBy
        isArchivedUsers
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncInitiateClassifiedWeeklyAbsenceReports = /* GraphQL */ `
  query SyncInitiateClassifiedWeeklyAbsenceReports(
    $filter: ModelInitiateClassifiedWeeklyAbsenceReportFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncInitiateClassifiedWeeklyAbsenceReports(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        user_id
        status
        school_id
        from_date
        to_date
        status_date_time
        approver_status
        approver_by
        approver_date_time
        payroll_status
        payroll_by
        payroll_date_time
        approver_remark
        payroll_remark
        l1_authority
        l2_authority
        comment
        customUpdatedAt
        isSoftDelete
        isArchived
        updatedBy
        deletedBy
        isArchivedUsers
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getAbsentCode = /* GraphQL */ `
  query GetAbsentCode($id: ID!) {
    getAbsentCode(id: $id) {
      id
      code
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listAbsentCodes = /* GraphQL */ `
  query ListAbsentCodes(
    $filter: ModelAbsentCodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAbsentCodes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        code
        name
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncAbsentCodes = /* GraphQL */ `
  query SyncAbsentCodes(
    $filter: ModelAbsentCodeFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncAbsentCodes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        code
        name
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getGrades = /* GraphQL */ `
  query GetGrades($id: ID!) {
    getGrades(id: $id) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listGrades = /* GraphQL */ `
  query ListGrades(
    $filter: ModelGradesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGrades(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncGrades = /* GraphQL */ `
  query SyncGrades(
    $filter: ModelGradesFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncGrades(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getSchools = /* GraphQL */ `
  query GetSchools($id: ID!) {
    getSchools(id: $id) {
      id
      address
      city
      state_id
      zip_code
      is_active
      code
      name
      isValidator
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listSchools = /* GraphQL */ `
  query ListSchools(
    $filter: ModelSchoolsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSchools(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        address
        city
        state_id
        zip_code
        is_active
        code
        name
        isValidator
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncSchools = /* GraphQL */ `
  query SyncSchools(
    $filter: ModelSchoolsFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSchools(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        address
        city
        state_id
        zip_code
        is_active
        code
        name
        isValidator
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getOrganizations = /* GraphQL */ `
  query GetOrganizations($id: ID!) {
    getOrganizations(id: $id) {
      id
      organization_email
      organization_phone_number
      about_organization
      address
      city
      state_id
      zip_code
      domain_name
      is_active
      name
      code
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listOrganizations = /* GraphQL */ `
  query ListOrganizations(
    $filter: ModelOrganizationsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        organization_email
        organization_phone_number
        about_organization
        address
        city
        state_id
        zip_code
        domain_name
        is_active
        name
        code
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncOrganizations = /* GraphQL */ `
  query SyncOrganizations(
    $filter: ModelOrganizationsFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncOrganizations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        organization_email
        organization_phone_number
        about_organization
        address
        city
        state_id
        zip_code
        domain_name
        is_active
        name
        code
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
